import { render } from "./CorpusGraphViewNew.vue?vue&type=template&id=29b9b34a"
import script from "./CorpusGraphViewNew.vue?vue&type=script&lang=js"
export * from "./CorpusGraphViewNew.vue?vue&type=script&lang=js"

import "./CorpusGraphViewNew.vue?vue&type=style&index=0&id=29b9b34a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__